export default __webpack_public_path__ + "static/media/8.d1676f9a.jpg";